/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Video from '../../components/video'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Highlighter } from '../highlighter'
import { Image, Link } from '@ta-interaktiv/contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '989717028228'
const isMobile = window.innerWidth < 600
const isSmallMobile = window.innerWidth < 400

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <header className='ui vertical very fitted segment header'>
        <div className='gallery'>
          <div className='gradient' />
          <div className='ui container inverted headerWrapper'>
            <div className='ui header'>
              <h1>
                Warum sprang der{' '}
                <span style={{ whiteSpace: 'nowrap' }}>19-Jährige</span> aus dem
                Fenster?
              </h1>
              <h2>
                Im April 1972 hechtete ein junger Mann auf LSD aus dem dritten
                Stock einer Zürcher Wohnung. Die Polizei fand Waffen und TNT.
                Andreas Tobler recherchierte für ein Buch, was wirklich an der
                Bändlistrasse geschah.
              </h2>
            </div>
          </div>
        </div>
        {/* <div className='ui container'>
          <div className='ui header'>
            <h1>Warum sprang der 19-Jährige aus dem Fenster?</h1>
            <h2>
              Im LSD-Rausch hechtete im April 1972 ein junger Mann aus dem
              dritten Stock einer Wohnung an der Zürcher Bändlistrasse. Die
              Polizei findet in der Wohnung Waffen, Sprengstoff und an einer
              Wand die Aufschrift RAF. Andreas Tobler hat ein Buch geschrieben,
              weil er wissen wollte, was damals in der Wohnung an der Zürcher
              Bändlistrasse geschah.
            </h2>
          </div>
        </div> */}
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Andreas Tobler</div>
            <div className='ta updated'>Aktualisiert am 23. April 2022</div>
          </div>
          <div className='ta text'>
            <p>
              Es ist Sommer, und ich warte auf einer Parkbank irgendwo in der
              Ostschweiz auf einen Mann, der bei einem Ereignis dabei war, über
              das damals in ganz Europa, Brasilien, Guatemala, Vietnam und den
              USA berichtet wurde: Am Morgen des 25. April 1972 springt der
              19-jährige Werner Meier aus dem Fenster einer Wohnung an der
              Bändlistrasse in Zürich-Altstetten.
            </p>
            <p>
              Nackt und mit der vollen Wucht seines Körpers durchbricht er die
              Scheibe und die heruntergelassene Jalousie – und fliegt aus der
              Wohnung im dritten Stock. Schwer verletzt bleibt Meier auf dem
              Rasenstück der Neubausiedlung liegen. Bei der anschliessenden
              Hausdurchsuchung findet die Polizei Waffen, Sprengstoff und an der
              Wand in roter Farbe die Buchstaben «RAF».
            </p>
            <Highlighter
              baseImage={require(isMobile
                ? '../../images/wohnung.jpg'
                : '../../images/wohnung.jpg')}
              overlayImage={require(isMobile
                ? '../../images/wohnung-overlay-mobile.jpg'
                : '../../images/wohnung-overlay.jpg')}
              caption='Funkgeräte, Einbruchwerkzeug, Chaos: Blick ins Schlafzimmer der Bändlistrasse-Wohnung.'
              source='Foto: Schweizerisches Bundesarchiv'
            />
            <p>
              Die Schweizer Öffentlichkeit war alarmiert. Auch weil just an dem
              Tag, als Bundesanwalt Hans Walder seine ersten
              Ermittlungsergebnisse zur Bändlistrasse publik machte, auf der
              Armeebasis in Heidelberg zwei Autobomben explodierten. Drei
              Menschen verloren ihr Leben. Die RAF um Andreas Baader und Gudrun
              Ensslin bekannte sich zum Anschlag. Das Attentat gehörte zur
              blutigen Mai-Offensive, bei der vier Menschen getötet und 74
              verletzt wurden.
            </p>
            <h3>«Gopfertammisiech. Jetzt ist fertig.»</h3>
            <p>
              50 Jahre später warte ich auf den einzigen Überlebenden, der beim
              ominösen Fenstersprung dabei war. In Polizeiakten konnte ich
              lesen, dass Kurt Koller nach dem Auffliegen der Bändlistrasse –
              nur wenige Tage vor der Mai-Offensive – bei der RAF in Stuttgart
              war. Andreas Baader soll sich für ihn und Werner Meier
              interessiert haben. Die beiden Schweizer sollen ihre Freundinnen
              verlassen – und sich der RAF anschliessen, meinte der RAF-Führer.
            </p>
            <p>
              Noch etwas hatte ich im Archiv gefunden: Ein Tonband, auf dem drei
              Männer miteinander reden, teils schwer verständlich, offenbar ist
              zumindest einer auf Drogen. Dann hört man, wie es laut klirrt und
              knallt, ganz so, als würde ein Stein auf eine grosse Scheibe
              treffen. Es herrscht sekundenlange Stille, bis ein Mann mit
              Ostschweizer Dialekt schockiert ruft: «Gopfertammisiech. Jetzt ist
              fertig.»
            </p>
          </div>
        </div>
      </div>
      <div className='ui vertical segment video left'>
        <div className='ui text container'>
          <div className='intro'>
            <img
              className='ui fluid image soundwave'
              src={require('../../images/soundwave.svg')}
            />
            {/* <i className='icon volume up' /> */}
            <div className='wrapper'>
              <div className='overline'>Originalaufnahme</div>
              <div className='scene'>
                Hören Sie hier die Aufnahme des Fenstersprungs
              </div>
            </div>
          </div>
        </div>
        <div className='ui container'>
          <Video
            url='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger%7CvideoId@444575%7CshowLogo@1%7CautoStart@0%7Cmute@0%7CshowAds@0%7CpreviewPath@https://unitythumb.appuser.ch/frames/uv444575/frame-1-444575.jpg%7Cplatform@desktop'
            caption='Im paranoiden Wahn springt Werner Meier am Morgen des 25. April 1972 durch das Fenster der Bändlistrasse-Wohnung.'
            source='Tonaufnahme: Stadtarchiv Zürich, Fotos: Schweizerisches Bundesarchiv/Stadtarchiv Zürich'
          />
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Der Ostschweizer ist Kurt Koller, damals 19 Jahre alt. Eine gute
              Stunde warte ich jetzt auf ihn, dann taucht er auf.
            </p>
            <Image
              file={require('../../images/kurt-5-mobile.jpg')}
              className='cbImage kurt'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              source={
                <>
                  <div className='caption'>
                    Beim Aktenstudium: Kurt Koller war dabei, als Werner Meier
                    aus der Wohnung an der Bändlistrasse sprang.
                  </div>
                  <div className='sourceTwo'>Foto: Sabina Bobst</div>
                </>
              }
            />

            {/* <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/flussdiagramm-antigentest-mobile.svg')
                  : require('../../images/flussdiagramm-antigentest-desktop.svg')
              }
              className='cbImage flussdiagramm'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quelle: Robert Koch Institut'
            /> */}
            <p>
              Die Geschichte der RAF füllt inzwischen Bibliotheken. Auch Meier
              ist zu einer Art Legende geworden: Vom «Bändli-Meier» wird dann
              gesprochen und seinem Fenstersprung – in dessen Folge in
              Zürich-Altstetten eine Art Mini-RAF aufgeflogen sei, die Kontakt
              zu ihrem deutschen Vorbild gehabt haben soll.
            </p>
            <p>
              Aber wie stark die sechs Mitglieder der Gruppe Bändlistrasse
              tatsächlich involviert waren, was sie antrieb und was danach aus
              ihnen wurde, wusste niemand so recht. Stattdessen verbreiteten
              sich wilde Gerüchte, Mutmassungen und Verschwörungstheorien, wer
              damals alles dabei gewesen sein soll. Auch rund um die
              Schlüsselepisode des Fenstersprungs blieb vieles unklar.
            </p>
            <h3>«He, hör auf, leg die Pistole weg!»</h3>
            <p>
              Das machte mich neugierig. Ich wollte wissen, was dahintersteckt
              und was wirklich an jenem Frühlingsmorgen geschah. Für mein Buch
              traf ich alle vier noch lebenden Mitglieder der
              Bändlistrasse-Gruppe - und führte über fast ein Jahr hinweg
              mehrstündige Gespräche mit ihnen. Ich stellte beim Eidgenössischen
              Justiz- und Polizeidepartement Anträge für Akteneinsicht, las
              tausende Aktenseiten – und fand plötzlich in einer Schachtel jenes
              Tonband, auf dem der legendäre Fenstersprung zu hören ist.
            </p>
            <p>
              Auf der Aufnahme sind die 45 Minuten vor dem Fenstersprung zu
              hören. Zustande gekommen ist es, weil Koller seinen Kollegen
              Werner Meier aufgenommen hatte – um ihm später vorspielen zu
              können, wie dieser reagiert, wenn er zu viele Trips nahm:
            </p>
            {/* <div className='quote-element'>
              <p className='quote'>
                «Bei Hingis kamen drei Diskriminierungsebenen zusammen:
                Herkunft, Geschlecht, Fähigkeit.»
                <div className='person'>Damir Skenderovic</div>
              </p>
            </div> */}
          </div>
        </div>
      </div>
      <div className='ui vertical segment video right'>
        <div className='ui text container'>
          <div className='intro'>
            <img
              className='ui fluid image soundwave'
              src={require('../../images/soundwave.svg')}
            />
            <div className='wrapper'>
              <div className='overline'>Originalaufnahme</div>
              <div className='scene'>
                Letzte Gespräche vor dem Fenstersprung
              </div>
            </div>
          </div>
          <div className='ta text dialog'>
            <p className='dialog one'>
              <b>Koller</b>: «Flippst du jetzt aus? Spinnst du jetzt eigentlich?
              Wirst du immer so weiter reagieren?»
            </p>
            <p className='dialog two'>
              <b>Meier</b>: «Ab jetzt, ja.»
            </p>
            <p className='dialog one'>
              <b>Koller</b>: «Findest du das gut?»
            </p>
            <p className='dialog two'>
              <b>Meier</b>: «Ja, du nicht?»
            </p>
            <p className='dialog one'>
              <b>Koller</b>: «Was machst du da?»
            </p>
            <p className='dialog two'>
              <b>Meier</b>: «Die Strassensperre einzeichnen. Da wollen wir
              durch. D’Schmier fahrt ih. [...] Was willst du, dass ich mache?
              Dass ich rausgehe und schiesse?»
            </p>
            <p className='dialog one'>
              <b>Koller</b>: «He, hör auf. Du bist auf einem Trip. Leg die
              Pistole weg. Komm, setz dich. Come on. Du hattest Trips, du
              hattest Kokain. Es ist gar niemand da.»
            </p>
          </div>
        </div>
        <div className='ui container' style={{ marginTop: '2em' }}>
          <Video
            url='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger%7CvideoId@444576%7CshowLogo@1%7CautoStart@0%7Cmute@0%7CshowAds@0%7CpreviewPath@https://unitythumb.appuser.ch/frames/uv444576/frame-1-444576.jpg%7Cplatform@desktop'
            caption='Einzigartiges Dokument: Kurt Koller wollte dokumentieren, wie Werner Meier reagiert, wenn dieser zu viele LSD-Trips konsumiert.'
            source='Tonaufnahme: Stadtarchiv Zürich, Fotos: Schweizerisches Bundesarchiv/Stadtarchiv Zürich'
          />
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Offensichtlich war Meier am Morgen des 25. April 1972 in einer Art
              paranoidem Wahn: Er glaubte, dass ihre Gruppe verraten worden sei,
              dass das Militär die Autobahn abriegle – und die Polizei mit allen
              verfügbaren Einheiten unterwegs sei an die Bändlistrasse.
            </p>
            <h3>Flucht aus Angst vor Mordverdacht</h3>
            <p>
              Deshalb sprang Meier aus dem Fenster. Seine Kollegen waren
              schockiert. Einer von ihnen war hörbar aufgelöst. Aber die
              Verzweiflung dauerte nur einen kurzen Moment, dann ging alles ganz
              schnell:
            </p>
            <div className='einzug left'>
              <p>
                «Wo hast du die Waffe?»
                <br />
                «Zuoberst im Küchenkasten.»
                <br />
                «Zum Glück habe ich das Auto unten [geparkt].»
                <br />
                «Hast du die Pistole im Sack?»
              </p>
            </div>
            <p>
              Dann waren die zwei Männer, die damals in der Wohnung waren, weg.
              Ohne Erste Hilfe geleistet zu haben, weil sie annahmen, Meier sei
              tot – und der Fenstersprung würde ihnen als Mord in die Schuhe
              geschoben werden.
            </p>
            <h3>Wie man ein Kaba-Schloss knackt</h3>
            <p>
              50 Jahre später sitze ich bei Koller am Stubentisch. Über vieles
              erzählt er bereits beim ersten Treffen ganz offen: Wie einfach es
              damals zum Beispiel gewesen sei, Autos zu knacken, um damit zum
              Spass durch die Stadt zu rasen. Oder wie man Schlösser von
              Geschäften aufbrechen konnte: In seinem Wohnzimmer öffnet der
              69-Jährige die Schublade einer Kommode, entnimmt ihr ein altes
              Kaba-Schloss – und zeigt, wie man es mit Werkzeug knackt: «Hier
              muss man mit dem Gabelschlüssel ansetzen und den Zylinder
              abwürgen», sagt er und umschliesst mit zwei Fingern ein Ende des
              Doppelzylinders. Danach ging fast jede Tür auf.
            </p>
            <p>
              Mit der Kaba-Methode konnten die Mitglieder der Gruppe
              Bändlistrasse fast überall einsteigen – etwa in ein Coiffeur-, ein
              Spielwaren- oder ein Damenmodegeschäft. Sie brachen die
              Registrierkassen auf und erbeuteten so viel Geld, dass sie als
              Kleinkriminelle davon leben konnten.
            </p>
            <h3>Wurde damals nicht das Frauenstimmrecht eingeführt?</h3>
            <p>
              An die politischen Diskussionen der radikalen Linken zu Beginn der
              70er-Jahre scheint sich Koller nicht mehr erinnern zu können.
              «Damals wurde das Frauenstimmrecht eingeführt, nicht?», fragt er
              einmal, als ich ihn darauf anspreche.
            </p>
            <p>
              Damals geschah aber auch noch mehr: Im Januar 1971 wurde das
              autonome Jugendzentrum im Lindenhofbunker Zürich geschlossen, um
              das die Zürcher 68er-Bewegung seit den Globuskrawallen so heftig
              gekämpft hatte.
            </p>
            <Image
              file={require('../../images/lindenhofbunker.jpg')}
              className='cbImage lindenhofbunker'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              source={
                <>
                  <div className='caption'>
                    Wurde im Januar 1971 von der Polizei aufgelöst: Der
                    Lindenhofbunker gegenüber der Zürcher Urania-Wache war ein
                    autonomes Jugendzentrum, in dem viele Heimzöglinge auf ihrer
                    Flucht Unterschlupf fanden.
                  </div>
                  <div className='sourceTwo'>Foto: Keystone</div>
                </>
              }
            />
            <p>
              Für die jungen Rebellen war es eine Niederlage, über die sie nur
              schwer hinwegkamen: Einige von ihnen gründeten im April 1971 die
              Proletarische Kampforganisation, eine Art Kaderorganisation der
              sogenannten Bunkerbewegung, in der schon bald über die Herausgabe
              der «Neuen Strassenverkehrsordnung» diskutiert wurde: Eine Schrift
              des RAF-Anwaltes Horst Mahler, die unter dem scheinbar
              unverfänglichen Titel zum bewaffneten Kampf aufrief. Der Antrag
              wurde mit elf zu einer Gegenstimme angenommen: Die Proletarische
              Kampforganisation druckte die RAF-Tarnschrift in mehreren Hundert
              Exemplaren im Sekretariat des Kleinen Studentenrates der
              Universität Zürich.
            </p>
            <h3>Weil es nichts ist, worauf man stolz sein kann</h3>
            <p>
              Während der Gespräche mit den Zeitzeugen stellte ich fest, dass es
              für viele noch heute schwierig ist, über die damalige Zeit zu
              sprechen: Wie die Umstände und die Stimmung in den Jahren nach
              1968 waren, ist heute nur schwer zu vermitteln. Wie empörend man
              es etwa fand, dass nur tausend Kilometer von Zürich entfernt in
              Spanien ein faschistisches Regime existierte, das Menschen noch
              bis ins Jahr 1975 mit der Garotte hinrichtete: Einem Eisendorn,
              der den Gefesselten so lange ins Genick getrieben wurde, bis sie
              tot waren.
            </p>
            <p>
              Die Männer und Frauen aus der 68er-Generation erzählen mir
              wiederholt, wie beschränkt damals die Freiräume in Zürich waren.
              In Parks habe man sich noch nicht einmal auf eine Wiese setzen
              dürfen. Aus den Akten gewinnt man den Eindruck, dass sich die
              Polizei und die Protestierenden gegenseitig hochschaukelten – eine
              explosive Gemengelage zwischen Protest und staatlicher Repression,
              die zunahm, je verbissener die Revoltierenden um ihre Anliegen
              kämpften. Es verstärkte sich bei ihnen das Gefühl, auch sie würden
              gegen ein faschistisches Regime kämpfen, das sich mit dem
              vermeintlich ebenso faschistischen Kapitalismus verbündet hatte.
              Bis einige von ihnen zur Auffassung kamen, dass es legitim sei,
              Gewalt anzuwenden, um politische Ziele zu erreichen und den Staat
              zu liquidieren.
            </p>
            <p>
              Damals habe alles seine Richtigkeit gehabt, sagt eine, die bei den
              Diskussionen über die sogenannten Gewaltfrage dabei war. Daher
              bereue sie nichts. Aber es sei auch nichts, worauf man stolz sein
              könne. Deshalb sei es so schwierig, darüber zu sprechen.
            </p>
            <p>
              Auch Koller hat Mühe, aber aus einem anderen Grund: Seit einem
              Motorradunfall, bei dem er sich Kopfverletzungen zuzog, fällt es
              ihm schwer, sich an weit zurückliegende Ereignisse zu erinnern. Es
              hilft ihm, wenn er sich Dokumente anschauen kann – dann kommen
              seine Erinnerungen wieder hoch.
            </p>
            <p>
              So ist das auch an diesem Vormittag, an dem wir das Jugendheim
              Platanenhof im st.-gallischen Oberuzwil besuchen: Hierhin war
              Koller in den 1960er Jahren gekommen. Und hier hatte er Werner
              Meier kennen gelernt, der in der Anstalt wie Koller eine
              Schreinerlehre absolvierte. Der Heimalltag war damals
              durchorganisiert wie in einer Militärkaserne – die 68er-Bewegung
              nannte die Einrichtungen «kapitalistische Anpassungslager». Um
              sich vom tristen Alltag etwas abzulenken, schnüffelten Koller und
              Meier in den Pausen Lösungsmittel. Sie freundeten sich an – und
              sollten bald gemeinsam die Gruppe Bändlistrasse gründen.
            </p>
            <h3>«Mir ging es nur um das Geld»</h3>
            <p>
              Wenn die Jugendlichen nicht spurten, wurden sie während mehrerer
              Tage oder gar Wochen ins «Cachot» gesperrt: eine Zelle ohne Bücher
              oder andere Ablenkungsmöglichkeiten. Auch wurden ihnen als Strafe
              die Köpfe geschoren, was Ende der 60er-Jahre, als Langhaarfrisuren
              in Mode kamen, für die jungen Männer ein schwerer Eingriff in die
              Selbstbestimmung war.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <Image
            file={
              browserCheck.isMobile
                ? require('../../images/koller-aktenstudium-quadratisch.jpg')
                : require('../../images/koller-aktenstudium-169.jpg')
            }
            className='cbImage'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source={
              <>
                <div className='caption'>
                  Erinnerungen kommen zurück: Kurt Koller schaut sich im
                  Erziehungsheim Platanenhof in Oberuzwil seine Akten an, in dem
                  seine Jugendsünde protokolliert sind.
                </div>
                <div className='sourceTwo'>Foto: Sabina Bobst</div>
              </>
            }
          />
        </div>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Auch Koller musste ins «Cachot». Bei unserem Besuch spricht er
              ohne Wut übers Jugendheim, ohne zu verschweigen, wie streng damals
              der Alltag war: «Hier mussten wir jeden Morgen und nach dem
              Mittagessen zum Appell antreten», sagt Koller, als wir über einen
              Platz zum Hauptgebäude gehen, wo wir seine Akte einsehen können.
            </p>
            <p>
              Aus den Dokumenten erfahren wir, warum Koller ins Heim gekommen
              war: Weil er sich als 13-Jähriger am St. Galler Bahnhof
              prostituiert hatte. «Man konnte innert kürzester Zeit 20 Franken
              verdienen», man habe dafür nur «sein Schwänzchen zeigen müssen»,
              sagt Koller. 20 Franken seien damals viel Geld gewesen. Emotional
              hätten ihn die wesentlich älteren Männer überhaupt nicht berührt.
              «Mir ging es nur um das Geld.»
            </p>
            <h3>Flucht aus dem «kapitalistischen Anpassungslager»</h3>
            <p>
              Im Februar 1971 hauten Meier und Koller aus dem Jugendheim in
              Oberuzwil ab – nach Zürich: Sie hatten gehört, dass sich im
              Dezember im Lindenhofbunker die Zürcher Heimkampagne gegründet
              hatte, eine politische Organisation, die nichts weniger verlangte
              als die Abschaffung aller Erziehungsheime.
            </p>
            <p>
              Mit ihrer Flucht aus dem Platanenhof waren Koller und Meier auf
              einen Schlag Teil eines hochpolitischen Kontextes geworden: Sie
              erhielten Kontakte zu den grossen Kommunen, nahmen an politischen
              Schulungskursen teil und an Demos: Bei einer Protestaktion für die
              inhaftierte US-Aktivistin Angela Davis warfen sie Steine und seien
              «wie Verrückte» auf die Polizei losgegangen.
            </p>
            <p>
              Aber die beiden jungen Männer suchten auch den schnellen Spass: Im
              Herbst 1971 begannen sie, Luxusautos zu klauen. Mit Vorliebe edle
              Jaguar, mit denen man «mit emene Lappe 30 durch d Stadt durefile»,
              also mit 130 durch die Stadt rasen konnte. Sie wurden geschnappt.
              Koller kam in Untersuchungshaft.
            </p>

            <Image
              file={require('../../images/fahndungsfoto-kurt-koller.jpg')}
              className='cbImage fahndungsfoto'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              source={
                <>
                  <div className='caption'>
                    Kurt Koller im November 1971, nachdem er wegen dem Diebstahl
                    von zahlreichen Luxusautos verhaftet worden war.
                  </div>
                  <div className='sourceTwo'>Foto: Stadtarchiv Zürich</div>
                </>
              }
            />

            <p>
              Die Wut der beiden aufs System erreichte nun ihren Höhepunkt. Sie
              begannen sich zu radikalisieren, weil die Zürcher Autonomen zwar
              immer wieder vom bewaffneten Kampf sprachen, aber nichts taten.
              Das wollten Koller und Meier nun eigenhändig ändern – zusammen mit
              ihren Freundinnen, einem Psychologiestudenten und einem
              Kochlehrling.
            </p>
            <h3>Bändlistrasse stellt TNT her</h3>
            <p>
              Die Vorbereitungen auf den bewaffneten Kampf fielen der Gruppe
              Bändlistrasse erstaunlich leicht: Sie konnten unbehelligt in eine
              Waffenfabrik in Feuerthalen ZH einbrechen. In einer Zürcher
              Buchhandlung beschafften sie sich das «Anarchist Cookbook», das
              damals frei erhältlich war – und Anleitungen zur Herstellung von
              Sprengstoff und Drogen enthielt.
            </p>
            <Highlighter
              baseImage={require(isMobile
                ? '../../images/wohnung-2.jpg'
                : '../../images/wohnung-2.jpg')}
              overlayImage={require(isMobile
                ? '../../images/wohnung-2-overlay-mobile.jpg'
                : '../../images/wohnung-2-overlay.jpg')}
              caption='Als die Polizei den Raum betrat, soll noch eine Flamme unter den Destillationskolben gebrannt haben: Das Sprengstofflabor an der Bändlistrasse.'
              source='Foto: Schweizerisches Bundesarchiv'
            />
            <p>
              «Wir haben gemischt, gebraut und gekocht, stunden-, ja
              nächtelang», gab Koller der Polizei nach seiner Verhaftung zu
              Protokoll. Dabei war ihnen in der Bändlistrasse offensichtlich
              gelungen, TNT-Kristalle herzustellen, wie Analysen der Polizei
              später ergaben. Die Mitglieder der Gruppe wollten dies im
              Nachhinein nicht bemerkt haben, obwohl die Herstellung von
              Sprengstoff ihr Ziel war. Die dafür notwendigen Substanzen hatten
              sie bei einem Einbruch in eine Chemiefirma erbeutet.
            </p>
            <h3>Nächtliche Gespräche mit Baader</h3>
            <p>
              Aber letztlich waren die Mitglieder der Gruppe Bändlistrasse
              Dilettanten – auch bei ihrem Kleinkriminellentum.
            </p>
            <p>
              Und als sie im April 1972 auf bewaffnete Überfälle umsteigen
              wollten, weil die Ausbeute bei den Einbrüchen zu gering war,
              wurden sie nervös, zögerten immer wieder – und nahmen
              offensichtlich viel zu viele Drogen. Mit dem Resultat, dass Werner
              Meier letztlich voller Paranoia aus dem Fenster sprang.
            </p>
            <p>
              Doch für Koller ging es weiter, das Auffliegen der Bändlistrasse
              ermöglichte ihm ein Rendez-vous mit der Weltgeschichte: Er wurde
              von einem Bekannten nach Stuttgart gebracht zu Gudrun Ensslin und
              Andreas Baader. Andere Schweizer hatten damals bereits seit
              mehreren Jahren Kontakte zur RAF: Akten, die ich für mein Buch
              erstmals auswerten konnte, geben in aller Detailliertheit Auskunft
              über deren Gespräche mit Baader, Ensslin und Ulrike Meinhof, dass
              wir sozusagen live bei den Diskussionen dabei sind. Fast immer mit
              dabei war damals der Journalist und Politaktivist Rolf Thut,
              welcher der Kopf der Zürcher Heimkampagne war und über mehrere
              Jahre hinweg Andreas Baader und Ulrike Meinhof in Berlin,
              Frankfurt und Stuttgart besuchte.
            </p>
            <p>
              Auch die Gespräche von Kollers Besuch bei der RAF sind in den
              Akten protokolliert: Er warnte die Deutschen vor der Sprengung von
              Bomben über ein Funksignal, das sei viel zu gefährlich.
            </p>
            <h3>Verhaftung im Tessin</h3>
            <p>
              Als wir im Zürcher Stadtarchiv seine Akten anschauen, erinnert
              sich Koller, wie «kalt» Baader und Ensslin damals in Stuttgart ein
              weiteres RAF-Mitglied behandelt hätten. Diese Frau sei von Baader
              bei der Mai-Offensive dann massiv unter Druck gesetzt worden,
              erzählt mir später ein renommierter RAF-Forscher.
            </p>
            <p>
              Von den Schweizern war Baader hingegen begeistert. Vor allem, als
              er hörte, dass Werner Meier nach seinem Fenstersprung aus dem
              Triemlispital geflohen war: An der Aussenwand des Krankenhauses
              soll sich der 19-Jährige nachts mit Leintüchern aus dem 11.
              Stockwerk abgeseilt haben.
            </p>
            <Image
              file={require('../../images/tessin.jpg')}
              className='cbImage tessin'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              source={
                <>
                  <div className='caption'>
                    <b className='red'>C</b> Zeigt die Telefonkabine, wo Werner
                    Meier und seine Freundin von der Polizei festgenommen
                    wurden. Im Buch über die Bändlistrasse wird erzählt, wie
                    Mitglieder der Gruppe nach dem Fenstersturz flohen – und wie
                    sie schliesslich nach einer nächtlichen Schiesserei im
                    Tessin verhaftet wurden.
                  </div>
                  <div className='sourceTwo'>
                    Foto: Schweizerisches Bundesarchiv
                  </div>
                </>
              }
            />
            <p>
              Aber letztlich brachte Meiers Fenstersprung die Polizei auf die
              Spur der Terroristen: Sie konnte die Schweizer RAF-Verbindungen
              kurz vor der Mai-Offensive kappen – und zugleich Zürichs radikale
              Linke zerschlagen. Es kam zu zahlreichen Hausdurchsuchungen, einer
              der Anführer floh nach Chile. Für die Mitglieder der Bändlistrasse
              schnappte die Falle am 5. Mai 1972 im Tessin zu: Werner Meier,
              Kurt Koller, ihre Freundinnen und der Kochlehrling wurden
              verhaftet.
            </p>
            <h3>Fast ein Wunder</h3>
            <p>
              «Ich bin froh, dass ich auf dieser Seite stehe», sagt Koller, als
              wir Anfang dieses Jahres in St. Gallen an einem Imbissstand
              stehen. Und dass er überhaupt noch lebt – im Unterschied zu Werner
              Meier, der – wie Koller – harte Drogen konsumiert hatte: Meier
              starb im Dezember 1990. Fürs Buch habe ich auch sein Leben
              recherchiert. Werner Meier wurde 38 Jahre alt.
            </p>
            <p>
              An diesem Vormittag in St. Gallen lasen wir Kollers Fürsorgeakten
              bei der Kesb: Darin stand, wie ihn sein Vater als Kind so lange
              schlug, bis er blutüberströmt war. Und wie er 1990 nach seinem
              schweren Motorradunfall völlig mittellos aus den USA in die
              Schweiz zurückgekehrt war – und er danach unter epileptischen
              Anfällen litt.
            </p>
            <p>
              Sieben Jahre danach wurde die Vormundschaft wieder aufgehoben.
              «Ich würde die Situation von Herrn Koller fast als ein Wunder
              bezeichnen», schreibt sein Vormund in einem Akteneintrag. Seine
              Wiedereingliederung in die Gesellschaft sei «ein Erfolg!».
            </p>
            <h3>Zuflucht zu Gott</h3>
            <p>
              Koller selbst beschreibt es etwas anders: Nach seinem «blöden
              Unfall» habe er den Herrgott gefragt, warum er überhaupt noch
              leben dürfe. «Ich dankte ihm und bat ihn, mir zu helfen, den
              rechten Weg zu finden.» Er habe dann nochmals «den Kopf
              anschlagen» müssen, sagt Koller. «Wegen des vielen Alkohols, den
              ich in den Jahren vor meinem Unfall getrunken hatte, brauchte ich
              eine neue Leber. Ohne Transplantation wäre ich gestorben.» Nach
              der Operation sei der Kontakt zu Jesus «plötzlich viel intensiver
              und klarer geworden», erzählt Koller. «So ist es geblieben – und
              so will ich den Kontakt auch halten.»
            </p>
            <p>
              Heute liest Koller täglich in der Bibel. «Mehr oder weniger jeden
              Tag», korrigiert er. Er habe Kontakt zu Jesus, sagt er und sei
              Mitglied in einer freien evangelischen Gemeinde.
            </p>
            <Image
              file={require('../../images/kurt-36.jpg')}
              className='cbImage'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              source={
                <>
                  <div className='caption'>
                    Hat heute Kontakt mit Jesus: Kurt Koller ist heute 69 Jahre
                    alt. Mit seiner Vergangenheit hat er abgeschlossen
                  </div>
                  <div className='sourceTwo'>Foto: Sabina Bobst</div>
                </>
              }
            />

            <p>
              Ob ich den da hinten sehe, fragt Koller, als wir am Imbissstand
              stehen. Er zeigt auf einen Mann, der etwas verwahrlost wirkt. «Der
              sucht nach weggeworfenen Zigarettenstummeln, um sie fertig rauchen
              zu können.» Der Unbekannte bückt sich kurz darauf bei einem
              Abfallkorb, um einen Stummel aufzuheben.
            </p>
            <p>
              Das meint Koller, wenn er sagt, er sei froh, dass er auf dieser
              Seite stehe: Nach einer langen Phase der Delinquenz, des Drogen-
              und Alkoholmissbrauchs hat er doch noch die Kurve gekriegt. Und
              niemand musste wegen ihm sein Leben lassen, als er die rote Linie
              hin zum Terrorismus überschreiten wollte.
            </p>
          </div>
        </div>
        <div className='ui ta text container buchbox'>
          <img
            className='buchcoverLeft'
            src={require('../../images/buchcover-baendlistrasse.jpg')}
          />
          <p>
            Das Buch von Andreas Tobler erzählt die Geschichte der gesamten
            Gruppe Bändlistrasse. Dank Gesprächen mit allen noch lebenden
            Gruppenmitgliedern und tausenden Aktenseiten gibt es einen intimen
            Blick in eine bis jetzt unbeschriebene Szene: Es zeigt auf, warum
            der Kreis um Kurt Koller und Werner Meier sich für den bewaffneten
            Kampf rüstete, über was Schweizer Linksaktivisten mit Andreas Baader
            und Gudrun Ensslin bei ihren Treffen diskutierten – und was aus den
            Angehörigen der Gruppe Bändlistrasse geworden ist. Über{' '}
            <Link href='https://echtzeit.ch/sonntagszeitung'>diesen Link</Link>{' '}
            erhalten Sie das Buch mit einem Rabatt für 26 statt für 29 Franken.
          </p>
          <p className='bookByline'>
            Andreas Tobler: Bändlistrasse. LSD, RAF, PKO und TNT.
            Echtzeit-Verlag, 160 Seiten, reich bebildert.{' '}
            <Link
              allowWordWrap
              href='https://kaufleuten.ch/event/andreas-tobler/'
            >
              Vernissage am 9. Mai im Kaufleuten Zürich
            </Link>
            .
          </p>
        </div>
        <div className='ui text container' style={{ marginTop: '2em' }}>
          <div className='ta text'>
            <p className='italic'>
              Wir danken dem Schweizerischen Bundesarchiv, dem Stadtarchiv
              Zürich, dem Jugendheim Platanenhof in Oberuzwil, dem Stadtarchiv
              St. Gallen und der Kesb St. Gallen für ihre Hilfe bei der
              Recherche.
            </p>
          </div>
        </div>

        <div className='ui text container' style={{ marginTop: '2em' }}>
          <iframe
            height='200px'
            width='100%'
            frameBorder='no'
            scrolling='no'
            seamless
            src='https://player.simplecast.com/bde739ee-90be-47c1-8985-13758ac3c94c?dark=true&color=2CA29F'
          />
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text', 'Andreas Tobler'],
          ['Video', 'Boris Gygax'],
          ['Digitale Umsetzung', 'Patrick Vögeli']
        ]}
      />
    </div>
  )
}
